import React from "react"
import scriptLoader from "react-async-script-loader"
import { Button } from "semantic-ui-react"
import styled from "styled-components"
import { postInternetBanking } from "../../api/async/payment"
import { getOrders } from "../../api/async/orders"
import { getParticipants } from "../../api/async/participants"
import { notification } from "antd"
import { InternetBankingButton } from "../InternetBankingButton"

const FullWidthButton = styled(Button)`
  width: 100%;
  max-width: 750px;
  min-height: 40px;
  max-height: 55px;
  height: 55px;
`

class OmiseButton extends React.Component {
  componentWillReceiveProps({ isScriptLoaded, isScriptLoadSucceed }) {
    if (isScriptLoaded && !this.props.isScriptLoaded) {
      if (isScriptLoadSucceed) {
        const { OmiseCard } = window
        OmiseCard.configure({
          publicKey: "pkey_5e2b84awv5w4e8cnxnb",
          //   publicKey: "pkey_test_5ey7a2jboywk0u2aayk",
          frameLabel: "Run24HRS",
          submitFormTarget: null,
          submitAuto: "no"
        })

        OmiseCard.configureButton("#checkout-button", {
          frameLabel: "Run24HRS"
        })

        OmiseCard.attach()
      }
    }
  }

  triggerOmiseForm = async e => {
    const { OmiseCard } = window
    const extractAmount = `${this.props.amount}`.split(".")
    const amount = `${extractAmount[0]}00`
    OmiseCard.open({
      amount,
      onCreateTokenSuccess: async token => {
        const { modified, targetId } = this.props
        let target = ""
        if (this.props.type === "orders") {
          const res = await getOrders({ id: targetId })
          target = res.data[0].modified
        } else {
          const res = await getParticipants({ id: targetId })
          target = res.data[0].modified
        }
        if (target !== modified) {
          notification.error({
            message: "EW01-เกิดข้อผิดพลาดขณะทำรายการกรุณาทำรายการอีกครั้ง"
          })
          return false
        }
        this.props.onSuccess(token, amount)
      },
      onFormClosed: e => {}
    })
  }

  payBank = bank => {
    const { Omise } = window
    // Omise.setPublicKey('pkey_test_5ey7a2jboywk0u2aayk')
    Omise.setPublicKey("pkey_5e2b84awv5w4e8cnxnb")

    const extractAmount = `${this.props.amount}`.split(".")
    const amount = `${extractAmount[0]}00`

    Omise.createSource(
      `internet_banking_${bank}`,
      { currency: "thb", amount },
      (statusCode, response) => {
        postInternetBanking({
          amount,
          target_id: this.props.targetId,
          type: this.props.type,
          source: response.id
        }).then(res => {
          if (typeof window !== "undefined")
            window.location.replace(res.data.authorize_uri)
        })
      }
    )
  }

  render() {
    return (
      <form onSubmit={e => e.preventDefault()}>
        <FullWidthButton
          id="checkout-button"
          style={{ marginBottom: "10px" }}
          onClick={this.triggerOmiseForm}
          color="teal"
        >
          บัตรเครดิต
        </FullWidthButton>
        {/* <InternetBankingButton onClick={this.payBank}/> */}
      </form>
    )
  }
}

export default scriptLoader("https://cdn.omise.co/omise.js")(OmiseButton)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/OmiseButton/index.js